import pizza from '../img/kindfood/pizza.jpg'
import fried from '../img/kindfood/fried.jpg'
import burger from '../img/kindfood/burger.jpg'
import sandwich from '../img/kindfood/sandwich.jpg'
import pasta from '../img/kindfood/pasta.jpg'
import before from '../img/kindfood/before.jpg'

export const kindFood=[
    {
        "id" : 0 ,
        "idNmae":'burgur',
        "title" : "برگر",
        "image" : burger,
    },
    {
        "id" : 1 ,
        "title" : "پیتزا",
        "idNmae":'pizza',
        "image" :pizza,
    },
    {
        "id" : 2 ,
        "title" : "ساندویچ",
        "idNmae":'sandwich',
        "image" :sandwich,
    },
    {
        "id" : 3 ,
        "title" : "سوخاری",
        "idNmae":'fried',
        "image" :fried,
    },
    {
        "id" : 4 ,
        "title" : "پاستا",
        "idNmae":'pasta',
        "image" :pasta,
    },
    {
        "id" : 5 ,
        "title" : "پیش‌‌‌‌غذا",
        "idNmae":'before',
        "image" :before,
    },

    
  
]